import { ErrorOutline } from "@mui/icons-material";
import { AlertTitle, Alert as BaseAlert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

interface Props {
  error?: FetchBaseQueryError | SerializedError;
}

export default function PurchaseAlert({ error }: Props) {
  const { t } = useTranslation();

  if (!error) {
    return null;
  }

  if ("status" in error && error.status === 409) {
    return (
      <BaseAlert data-testid="purchase-alert" severity="warning">
        <AlertTitle>{t("purchaseParkingPermit.conflict.title")}</AlertTitle>
        {t("purchaseParkingPermit.conflict.content")}
      </BaseAlert>
    );
  }

  return (
    <BaseAlert
      data-testid="purchase-alert"
      icon={<ErrorOutline fontSize="inherit" />}
      severity="error"
    >
      {t("unknownError")}
    </BaseAlert>
  );
}
